import * as React from 'react';

import { ElementInViewport } from '../../../common/components/element_in_viewport';
import { ISubscribeProps, Subscribe } from '../../../common/components/nothing_found/subscribe';
import { listTracking } from '../../../common/components/nothing_found/subscribe/tracking';
import { IJsonQuery } from '../../../json_query';
import * as styles from './index.css';

type TPickSubScribeProps = Pick<ISubscribeProps, 'isAuthenticated' | 'jsonQuery' | 'queryString' | 'subscriptionState'>;

export interface IStateProps extends TPickSubScribeProps {
  userEmail: string | undefined;
  isShortView: boolean;
  jsonQuery: IJsonQuery;
}

export type TDispatchProps = Pick<ISubscribeProps, 'onSubmit'>;

export type TBottomSubscribeProps = IStateProps & TDispatchProps;

export class BottomSubscribe extends React.Component<TBottomSubscribeProps> {
  public render() {
    const { isAuthenticated, jsonQuery, onSubmit, queryString, subscriptionState, userEmail, isShortView } = this.props;

    return (
      <div>
        <div className={styles['container']}>
          <div className={styles['subscribe-block']}>
            <div className={styles['subscribe-title']}>
              {isShortView ? 'Подпишитесь на новые объявления и новости ЦИАН' : 'Не нашли подходящий объект?'}
            </div>
            <div className={styles['formContainer']}>
              <ElementInViewport onChange={this.handleSubscribeShowInViewport}>
                <Subscribe
                  group={undefined}
                  inputValue={userEmail}
                  isAuthenticated={isAuthenticated}
                  isNothingFound={undefined}
                  jsonQuery={jsonQuery}
                  onSubmit={onSubmit}
                  queryString={queryString}
                  subscriptionState={subscriptionState}
                  containerStyle={styles['subscribeContainer']}
                  description={
                    isShortView
                      ? ''
                      : 'Как только по этому запросу появятся объявления, мы отправим их вам на электронную почту'
                  }
                />
              </ElementInViewport>
            </div>
          </div>
        </div>
      </div>
    );
  }

  private handleSubscribeShowInViewport = (visible: boolean) => {
    if (visible) {
      listTracking.trackShow(this.props.jsonQuery);
    }
  };
}
